export interface IAllocation {
    id: string;
    userId: string;
    userName: string;
    tickets: number;
    confirmed: number;
    pending: number;
    waiting: number;
    unused: number;
    requested: number;
    isRequestActive: boolean;
    sendRequestEmail: boolean;
    status: IStatus;
    distribution: IDistrubution;
    motivation: string;
}

export class Allocation implements IAllocation {
    constructor(
        public id: string,
        public userId: string,
        public userName: string,
        public tickets: number,
        public confirmed: number,
        public pending: number,
        public waiting: number,
        public unused: number,
        public requested: number,
        public isRequestActive: boolean,
        public sendRequestEmail: boolean,
        public status: IStatus,
        public distribution: IDistrubution,
        public motivation: string
    ) { }
}

export interface IUpdateAllocation {
    allocations: IAllocation[];
    idsToDelete: string[];
    canAccessUnallocated: boolean;
}

export class UpdateAllocation implements IUpdateAllocation {
    constructor(
        public allocations: IAllocation[],
        public idsToDelete: string[],
        public canAccessUnallocated: boolean,
    ) { }
}

export interface IAllocationTotal {
    status: any;
}

export interface IStatus {
    status: any;
    max: number;
}

export class Status implements IStatus {
    constructor(
        public status: any,
        public max: number,
    ) { }
}

export interface IDistrubution {
    min: number;
    max: number;
    current: number;
}

export class Distrubution implements IDistrubution {
    constructor(
        public min: number,
        public max: number,
        public current: number,
    ) { }
}

export interface IRequestTickets {
    requested: number;
    motivation: string;
}

export class RequestTickets implements IRequestTickets {
    constructor(
        public requested: number,
        public motivation: string
    ) { }
}
